'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoDeviceMobile = function GoDeviceMobile(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 0h-20c-1.4 0-2.5 1.1-2.5 2.5v35c0 1.4 1.1 2.5 2.5 2.5h20c1.4 0 2.5-1.1 2.5-2.5v-35c0-1.4-1.1-2.5-2.5-2.5z m-11.2 2.5h2.5c0.6 0 1.2 0.6 1.2 1.3s-0.6 1.2-1.2 1.2h-2.5c-0.7 0-1.3-0.6-1.3-1.2s0.6-1.3 1.3-1.3z m2.5 35h-2.5c-0.7 0-1.3-0.6-1.3-1.2s0.6-1.3 1.3-1.3h2.5c0.6 0 1.2 0.6 1.2 1.3s-0.6 1.2-1.2 1.2z m8.7-5h-20v-25h20v25z' })
        )
    );
};

exports.default = GoDeviceMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/device-mobile.js
// module id = 1878
// module chunks = 0